import { getRoleLabel, getRoleIndefiniteArticle } from './user';

import { getProject } from '../services/store-service';

import moment from 'moment';

import botImage from '../images/nifty-orbit.png';

export const NO_FLAG_ACTIVITIES = ['task.complete', 'subtask.complete'];

export const VALID_ACTIVITIES = [
    'system.alert',

    'team.join',
    'team.leave',

    'project.leave',
    'project.invite',
    'project.archive',

    'document.invite',
    'document.tag',

    'file.tag',

    'task.assign',
    'task.tag',
    'task.complete',
    'task.move',
    'task.archive',
    'task.alert',

    'subtask.assign',
    'subtask.complete',

    'thread.tag'
];

export const VALID_USER_ACTIVITIES = [
    'project.join',
    'project.leave',
    'project.archive',

    'document.invite',
    'document.comment',
    'document.tag',

    'file.comment',
    'file.tag',

    'task.assign',
    'task.comment',
    'task.tag',
    'task.complete',
    'task.move',
    'task.archive',

    'subtask.assign',
    'subtask.complete',

    'message.tag',
    'message.upload',

    'thread.tag'
];

export const VALID_ACTIVITIES_FOR_PANEL = [
    'system.alert',

    'team.join',
    'team.leave',

    'project.leave',
    'project.invite',
    'project.archive',

    'document.invite',
    'document.tag',

    'file.tag',

    'task.assign',
    'task.tag',
    'task.complete',
    'task.move',
    'task.archive',
    'task.alert',

    'subtask.assign',
    'subtask.complete',

    'thread.tag',
    'thread.comment'
];

export const FAVICON_CHANGE_ACTIVITIES = ['message.create'];

const PROJECT_MAIN_NOTIFICATION_TYPES = ['message', 'task', 'subtask', 'document', 'file'];

export const notificationIsUnread = notification => notification && !notification.is_read;

const isNotificationValid = notification => notification && VALID_ACTIVITIES_FOR_PANEL.includes(`${notification.type}.${notification.action}`);

export const getActivities = notifications => notifications.filter(isNotificationValid);

export const generateFilters = pairs =>
    pairs.reduce((filter, pair) => {
        const [type, action] = pair.split('.');
        if (!(type in filter)) {
            filter[type] = [];
        }

        filter[type].push(action);

        return filter;
    }, {});

export const getUnreadActivities = notifications => getActivities(notifications).filter(notificationIsUnread);

const getSystemMessage = text => {
    return text.replace(/^(Overdue\sTask:\s)(.+)$/, '$1**$2**');
}

const getSystemUrl = notification => {
    if (notification.url) {
        return notification.url;
    }

    if (notification.association && notification.association.type) {
        switch (notification.association.type) {
            case 'Task':
                return [notification.project.id, 'task', notification.association.id].join('/');

            default:
                // es lint
        }
    }

    return null;
}

export const getNotificationProps = (notification, currentUserId) => {
    const user = notification.user_in_question;
    const triggeredBy = notification.triggered_by;
    const project = notification.project ? ((notification.project.id && getProject(notification.project.id)) || notification.project) : null;
    const { team, association, receiver } = notification;
    const url = [];
    const text = [];
    const cardHead = [];
    const cardBody = [];
    const firstPersonText = [];
    const isSelf = () => currentUserId && triggeredBy && currentUserId === triggeredBy.id;
    const meta = [];
    let avatar = 'triggered_by';
    let includeTeam = true;

    switch (`${notification.type}.${notification.action}`) {
        case 'system.alert':
            avatar = 'nifty';
            text.push(getSystemMessage(notification.message));

            const systemUrl = getSystemUrl(notification);
            if (systemUrl) {
                url.push(systemUrl);
            }
            break;

        case 'team.join':
            avatar = 'team';

            text.push(`**${user.name}**`);
            text.push(`joined team **${team.name}**`);
            cardHead.push(`${user.name}`);
            cardHead.push(`joined team ${team.name}`);

            if (user.role) {
                text.push(`as ${getRoleIndefiniteArticle(user.role)} **${getRoleLabel(user.role)}**.`);
                cardHead.push(`as ${getRoleIndefiniteArticle(user.role)} ${getRoleLabel(user.role)}.`);
            }
            includeTeam = false;
            break;

        case 'team.leave':
            avatar = 'team';
            text.push(`**${(user || triggeredBy).name}**`);
            text.push(`has left team **${team.name}**.`);
            includeTeam = false;
            break;

        case 'team.invite':
            avatar = 'team';
            text.push(`**${(user || triggeredBy).name}**`);
            text.push(`has invited you to team **${team.name}**.`);
            includeTeam = false;
            break;

        case 'project.join':
            if (!project) {
                return null;
            }

            avatar = 'project';
            url.push(project.id);
            text.push(`**${user.name}**`);
            text.push(`joined project **${project.name}**`);
            cardHead.push(`${user.name}`);
            cardHead.push(`joined project ${project.name}`);

            firstPersonText.push(`Joined project "**${project.name}**"`);
            break;

        case 'project.invite':
            if (!project) {
                return null;
            }

            avatar = 'project';
            url.push(project.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`has added you to project **${project.name}**${project.archived ? ' **Archived**' : ''}.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`has added you to project ${project.name}${project.archived ? ' (Archived)' : ''}.`);

            firstPersonText.push(`Archived the project "**${project.name}**".`);
            break;

        case 'project.leave':
            if (!project) {
                return null;
            }

            avatar = 'project';
            text.push(`**${user.name}**`);
            text.push(`has left project **${project.name}**.`);

            firstPersonText.push(`Left project "**${project.name}**".`);
            break;

        case 'project.archive':
            avatar = 'project';
            url.push('settings', 'project', project.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`has archived a project **${project.name}**${project.archived ? ' **Archived**' : ''}.`);

            firstPersonText.push(`Archived project "**${project.name}**".`);
            break;

        case 'document.invite':
            url.push(project.id, 'documents', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`has shared the doc **${association.name}** with you.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`has shared the doc ${association.name} with you.`);
            cardBody.push(`In project ${project.name}`);

            if (!isSelf() && receiver) {
                firstPersonText.push(`Shared doc "**${association.name}**" with ${receiver.name}`);
            } else {
                firstPersonText.push(`Shared doc "**${association.name}**" with you`);
            }
            break;

        case 'document.tag':
            url.push(project.id, 'documents', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`mentioned you in a comment in doc **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`mentioned you in a comment in doc ${association.name}.`);
            cardBody.push(`In project ${project.name}`);

            if (!isSelf() && receiver) {
                firstPersonText.push(`Mentioned ${receiver.name} in doc "**${association.name}**"`);
            } else {
                firstPersonText.push(`Mentioned you in doc "**${association.name}**"`);
            }
            break;

        case 'document.comment':
            url.push(project.id, 'documents', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`commented in the doc **${association.name}**.`);

            firstPersonText.push(`Commented in doc "**${association.name}**"`);
            break;

        case 'file.tag':
            if (project) {
                url.push(project.id, 'files', 'file', association.id, 'comments');
            } else {
                url.push('files', association.id, 'comments');
            }

            text.push(`**${triggeredBy.name}**`);
            text.push(`mentioned you in a comment on file **${association.name}**.`);

            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`mentioned you in a comment on file ${association.name}.`);

            if (project) {
                cardBody.push(`In project ${project.name}`);
            }

            if (!isSelf() && receiver) {
                firstPersonText.push(`Mentioned ${receiver.name} in file "**${association.name}**"`);
            } else {
                firstPersonText.push(`Mentioned you in file "**${association.name}**"`);
            }
            break;

        case 'file.comment':
            if (project) {
                url.push(project.id, 'files', 'file', association.id, 'comments');
            } else {
                url.push('files', association.id, 'comments');
            }

            text.push(`**${triggeredBy.name}**`);
            text.push(`commented in the file **${association.name}**.`);

            firstPersonText.push(`Commented in file "**${association.name}**"`);
            break;

        case 'task.assign':
            url.push(project.id, 'task', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`assigned you the task **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`assigned you the task ${association.name}`);
            cardBody.push(`In project ${project.name}`);

            if (!isSelf() && receiver) {
                firstPersonText.push(`Assigned ${receiver.name} to task "**${association.name}**".`);
            } else {
                firstPersonText.push(`Assigned you to task "**${association.name}**".`);
            }
            break;

        case 'task.tag':
            url.push(project.id, 'task', association.id, 'comments');
            text.push(`**${triggeredBy.name}**`);
            text.push(`mentioned you in a comment in task **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`mentioned you in a comment in task ${association.name}.`);
            cardBody.push(`In project ${project.name}`);

            if (!isSelf() && receiver) {
                firstPersonText.push(`Mentioned ${receiver.name} in task "**${association.name}**".`);
            } else {
                firstPersonText.push(`Mentioned you in task "**${association.name}**".`);
            }

            break;

        case 'task.comment':
            url.push(project.id, 'task', association.id, 'comments');
            text.push(`**${triggeredBy.name}**`);
            text.push(`commented in the task **${association.name}**.`);

            firstPersonText.push(`Commented in task "**${association.name}**".`);
            break;

        case 'task.complete':
            url.push(project.id, 'task', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`completed task **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`completed task ${association.name}.`);
            cardBody.push(`In project ${project.name}`);

            firstPersonText.push(`Marked task "**${association.name}**" as Completed.`);
            break;

        case 'task.move':
            url.push(project.id, 'task', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`moved task **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`moved task ${association.name}.`);
            cardBody.push(`In project ${project.name}`);

            firstPersonText.push(`Moved task "**${association.name}**".`);
            break;

        case 'task.archive':
            avatar = 'project';
            url.push(project.id, 'task', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`has archived a task **${association.name}**.`);

            firstPersonText.push(`Archived task "**${association.name}**".`);
            break;

        case 'task.alert':
            avatar = 'project';
            url.push(project.id, 'task', association.id);
            text.push(`Your task **${association.name}** is **${moment(association.due_date).format('[due on] MMM. D [at] h:mma')}**.`);
            break;

        case 'subtask.assign':
            url.push(project.id, 'task', association.task_id, 'subtasks');
            text.push(`**${triggeredBy.name}**`);
            text.push(`assigned you the subtask **${association.name}**.`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`assigned you the subtask ${association.name}`);
            cardBody.push(`In project ${project.name}`);


            if (!isSelf() && receiver) {
                firstPersonText.push(`Assigned ${receiver.name} to subtask "**${association.name}**".`);
            } else {
                firstPersonText.push(`Assigned you to subtask "**${association.name}**".`);
            }
            break;

        case 'subtask.complete':
            url.push(project.id, 'task', association.task_id, 'subtasks');
            text.push(`**${triggeredBy.name}**`);
            text.push(`completed the subtask **${association.name}**`);
            cardHead.push(`${triggeredBy.name}`);
            cardHead.push(`completed the subtask ${association.name}`);
            cardBody.push(`In project ${project.name}`);

            firstPersonText.push(`Marked subtask "**${association.name}**" as Completed.`);
            break;

        case 'message.tag':
            if (project) {
                url.push(project.id, 'discussion', notification.message_id);
                text.push(`**${triggeredBy.name}**`);
                text.push(`mentioned you in the discussion **${association.name}**.`);
                cardHead.push(`${triggeredBy.name}`);
                cardHead.push(`mentioned you in the discussion ${association.name}.`);
                cardBody.push(`In project ${project.name}`);

                if (!isSelf() && receiver) {
                    firstPersonText.push(`Mentioned ${receiver.name} in project "**${project.name}**" discussion.`);
                } else {
                    firstPersonText.push(`Mentioned you in project "**${project.name}**" discussion.`);
                }
            } else {
                url.push(`#chat=${association.id}`)
                cardHead.push(`New direct message from ${triggeredBy.name}`);
                cardBody.push(notification.detailed_message);
                includeTeam = false;
            }
            break;

        case 'message.create':
            if (project) {
                url.push(project.id, 'discussion', notification.message_id);
                cardHead.push(`(${project.name})`);
                cardHead.push(`${triggeredBy.name} in ${association.name}`);
                cardBody.push(notification.detailed_message);
            } else {
                url.push(`#chat=${association.id}`)
                cardHead.push(`New direct message from ${triggeredBy.name}`);
                cardBody.push(notification.detailed_message);
                includeTeam = false;
            }
            break;

        case 'message.upload':
            if (project) {
                url.push(project.id, 'discussion', notification.message_id);
                cardHead.push(`(${project.name})`);
                cardHead.push(`${triggeredBy.name} in ${association.name}`);
                cardBody.push(notification.detailed_message);
                firstPersonText.push(`Uploaded a file in project "**${project.name}**" discussion.`);
            } else {
                url.push(`#chat=${association.id}`)
                cardHead.push(`New direct message from ${triggeredBy.name}`);
                cardBody.push(notification.detailed_message);
                includeTeam = false;
            }
            break;

        case 'message.doc':
            if (project) {
                url.push(project.id, 'discussion', notification.message_id);
                cardHead.push(`(${project.name})`);
                cardHead.push(`${triggeredBy.name} in ${association.name}`);
                cardBody.push(notification.detailed_message);
            } else {
                url.push(`#chat=${association.id}`)
                cardHead.push(`New direct message from ${triggeredBy.name}`);
                cardBody.push(notification.detailed_message);
                includeTeam = false;
            }
            break;

        case 'thread.tag':
            url.push(project.id, 'discussion', 'thread', association.id);
            text.push(`**${triggeredBy.name}**`);
            text.push(`mentioned you in a thread in **${project.name}**.`);
            cardHead.push(`(${project.name})`);
            cardHead.push(`${triggeredBy.name} mentioned you in a thread in ${project.name}`);
            cardBody.push(notification.detailed_message);

            if (!isSelf() && receiver) {
                firstPersonText.push(`Mentioned ${receiver.name} in a thread.`);
            } else {
                firstPersonText.push(`Mentioned you in a thread.`);
            }
            includeTeam = false;
            break;

        case 'thread.comment':
            url.push(project.id, 'discussion', 'thread', association.id);
            text.push(`New message in thread in **${project.name}** from`);
            text.push(`**${triggeredBy.name}**`);
            cardHead.push(`(${project.name})`);
            cardHead.push(`${triggeredBy.name} replied in thread in ${project.name}`);
            cardBody.push(notification.detailed_message);
            includeTeam = false;
            break;

        default:
            return null;
    }

    meta.push(notification.title);

    if (includeTeam) {
        meta.push(notification.team.name);
    }

    return {
        text: `${text.join(' ')}`,
        cardHead: `${cardHead.join(' ')}`,
        cardBody: `${cardBody.join(' ')}`,
        firstPersonText: `${firstPersonText.join(' ')}`,
        url: url.join('/'),
        meta: meta.join(' | '),
        avatar: avatar === 'nifty' ? {
            image: botImage
        } : {
            image: notification[avatar].avatar || notification[avatar].logo,
            color: notification[avatar].color,
            secondaryColor: notification[avatar].secondary_color,
            text: notification[avatar].initials
        }
    }
}

export const getLastUserActivity = (notifications, userId, validActivities = VALID_USER_ACTIVITIES) => notifications
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .find(notification => notification && validActivities.includes(`${notification.type}.${notification.action}`) && notification.triggered_by && notification.triggered_by.id === userId);

export const getNotificationsForProjects = (notifications, projectIds) => notifications
    .filter(notification => 
        notificationIsUnread(notification) &&
        notification.project &&
        projectIds.includes(notification.project.id) &&
        !NO_FLAG_ACTIVITIES.includes(`${notification.type}.${notification.action}`) &&
        (
            notification.type === 'project' ||
            PROJECT_MAIN_NOTIFICATION_TYPES.includes(notification.type)
        )
    );

export const getTaskNotifications = (notifications, taskId, all) => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.association &&
        (all || !NO_FLAG_ACTIVITIES.includes(`${notification.type}.${notification.action}`)) &&
        (
            notification.association.task_id === taskId ||
            notification.association.id === taskId
        )
    );

export const filterNotifications = (notifications, { projectId, associationId, association, type, customKey, customValue, tasksIds, taskId }) => {
    return notifications.filter(notification => {
        if (!notification || notification.is_read) {
            return false;
        }

        if (projectId) {
            return notification.project && notification.project.id === projectId;
        }

        if (associationId) {
            return notification.association_id === associationId;
        }

        if (association) {
            return notification.association === association;
        }

        if (type) {
            return notification.type === type;
        }

        if (customKey && customKey in notification) {
            return notification[customKey] === customValue;
        }

        if (taskId && notification.task) {
            return notification.task.id === taskId;
        }

        if (tasksIds && tasksIds.length) {
            return tasksIds.some(taskId => notification.association && (notification.association.id === taskId || notification.association.task_id === taskId));
        }

        return false;
    });
}
